import { DeleteForecastForReceiptRequest } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';

/**
 * グループ削除のアダプタ
 */
export class DeleteForecastForReceiptAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param forecastForReceiptId - グループID
   */
  public static adaptForRequest(forecastForReceiptId: string): DeleteForecastForReceiptRequest {
    return {
      deleteForecastForReceiptInfo: {
        forecastForReceiptId: forecastForReceiptId,
      },
    };
  }
}
